export default __webpack_public_path__ + "static/media/viscosoft-background.80b61ba8.svg";